import { render } from "./PopoversContainer.vue?vue&type=template&id=cb823db2&scoped=true"
import script from "./PopoversContainer.vue?vue&type=script&lang=js"
export * from "./PopoversContainer.vue?vue&type=script&lang=js"

import "./PopoversContainer.vue?vue&type=style&index=0&id=cb823db2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb823db2"]])

export default __exports__